function myFunction(para) {

  if(para==1) {
    
    /*if($("#open_close").css('display') == 'none') {
     $('.page-container').addClass('wash');
    } else {
  	 $('.page-container').removeClass('wash');  
    }*/
    
    $("#open_close").slideToggle(500);
    $(".menu_div_two").show();
    $(".toplmenu1").hide();
    $('.mobilemenu').hide();  
    $('.refer_popup_sec1').slideToggle();
    

    if(!$(".search_icon").hasClass("active"))
      setTimeout(function(){ $(".form_search_result input[type='search']").focus(); }, 500);

    $(".search_icon").toggleClass("active");
    
    // $(".form_search_result input[type='search']").focus();
    
  } else {
    var element = document.getElementById("PageContainer");
    // element.classList.toggle("wash");
    $("#open_close").slideToggle(500);
    $('.refer_popup_sec1').slideToggle();
    //$('#search').focus();
    $(".search_icon").toggleClass("active");
  }
}

function searchHover(){
  // $('.drawer-cover').hide();                                     
  hideCartDrawer(); // $('.drawer').hide('slide', {direction: 'right'}, 400);
  $('.cart-drawer__content').show(); 
}

function myFunctionmob() {
  //$('.page-container').toggleClass('wash');  
  
  /*if($("#open_close").css('display') == 'none') {
    $('.page-container').addClass('wash');  
  } else {
  	$('.page-container').removeClass('wash');  
  }*/

  var search_closed = $("#open_close").css('display') == 'block' ? false : true;


  $("#open_close").slideToggle(500);
  hideCartDrawer(); // $('.drawer').hide('slide', {direction: 'right'}, 400);
  // $('.drawer-cover').hide();
  
  if($(".mobilemenu").css('display') == 'block') {
    $('.mobilemenu').slideToggle();
    $('.icon--nav-anim').toggleClass('open');
  }else if(search_closed){
    //Focus on search if box has opened;
    if($('.mobile_search_enabled')[0]){
        $(".form_search_result input[type='search']").focus();
    }else{
        setTimeout(function(){ $(".form_search_result input[type='search']").focus(); }, 500);
    }
  }

  /*
  setTimeout(function() {
    if(($('.drawer').css('display') == 'none') && ($('#open_close').css('display') == 'none')) {
      $("#PageContainer").removeClass("wash");
    }
  },200);
  */
}

/* 
  Functions to add mobile search functionality to the site as well 
  as handle bugs from fast simons mobile search being injected.
*/
function init_mobile_search(){
  /* 
    Check to see if standard mobile search is enabled otherwise 
    fast simon will be used instead.
  */
  if($('.mobile_search_enabled')[0]){
    /* 
      Since fast simon doesn't have an event handler for when it 
      overrides mobile search we look for an onclick attribute 
      that fast simon adds to the search_icon. Because of this
      we don't want to use an onclick attribute for our standard 
      function at mobile smaller breakpoints so we add an onclick 
      event listener to mobile search icon insead of using an 
      attribute. We add this on window load because it prevents
      most cases of accessing the standard search before fast simon
      has a chance to load.
    */
    $(window).load(function () {
      $('.main_class_mobile .search_icon').on('click', function(){
        if(!$(this).attr("onclick")){
          myFunctionmob();
        }
      });
    });

    /* 
        Mobile searches may be replaced by Fast Simon
        To avoid issues we need to check for focus or 
        keyup when entering searches and manually prevent
        non mobile search from appearing.
    */
    $('.search_form input').on('focus keyup', function(event){
      var search_icon = $('.main_class_mobile .search_icon');

      /*
          By default onclick is not an attribute on the mobile search 
          icon. If there is an onclick attribute present then we know 
          fast simon has replaced the standard search with their mobile 
          search.
      */
      if(search_icon.attr("onclick")){

        /*
          If fast simon is using their mobile search we makse sure to 
          hide the non mobile search. 
        */
        $("#open_close").css('display', 'none');

        /*
          If this was caught using the keyup event then we know that 
          mobile search loaded after the user started typing in the 
          non mobile search. We open the correct search by simulating
          a new click on the search icon, and make sure to regular
          search doesn't appear open by removing its active class.
        */
        if(event.type == "keyup"){
          search_icon.click();
          search_icon.removeClass("active");
        }
      }
    });
  }
}
init_mobile_search();

function showCartDrawer(){
  // $('.drawer').show('slide', {direction: 'right'}, 400);
  $('.drawer').show("slow");
}
function hideCartDrawer(){
  // $('.drawer').hide('slide', {direction: 'right'}, 400);
  $('.drawer').hide("slow");
  $('.drawer-cover').hide();
}
function toggleCartDrawer(){
  // $('.drawer').toggle('slide', {direction: 'right'}, 400);
  $('.drawer').toggle("slow");
}

function showcart(para) {
  Shopify.onCartUpdate = function(cart) {
    Shopify.updateCartInfo(cart, '.cart-drawer');
  };
  if(para==1) {
    // Fix slide error
    // $('.drawer').show('slide', {direction: 'right'}, 400);
    showCartDrawer()
    
    /*if($('.page-container').not('wash')) {         
      $('.page-container').addClass('wash');  
    }*/
    
    $('.drawer-cover').show();                                    
    $('.header-top-user-menu').css({'right':'-310px'});

    if($('#CartCount').text()!='0') {
      $('.cart-drawer__empty-text').addClass('hide');
      $('.cart-drawer__footer').removeClass('hide');
    } else {
      $('.cart-drawer__footer').addClass('hide');
      $('.cart-drawer__empty-text').removeClass('hide');
    }
  } else {
    /*if($("#open_close").css('display') == 'block') {} else {
      $('.page-container').removeClass('wash');  
    }*/
    // $('.drawer-cover').hide();
    // Fix slide error
    // $('.drawer').hide('slide', {direction: 'right'}, 400);
    hideCartDrawer()
    $('.drawer').css({'display': "none"});

    $('.cart-drawer__content').show();
  }
}

function showcartmob() {
  toggleCartDrawer();// $('.drawer').toggle('slide', {direction: 'right'}, 400);
  
  /*if($(".drawer-cover").css('display') == 'none') {
    $('.page-container').addClass('wash');  
  } else {
    if($("#open_close").css('display') == 'block') {} else {
  	$('.page-container').removeClass('wash');  
    }
  }*/
  
  if($(".mobilemenu").css('display') == 'block') {
    $('.mobilemenu').slideToggle();
    $('.icon--nav-anim').toggleClass('open');
  }
  
  /*
  if($('.page-container').not('wash')) {         
    $('.page-container').addClass('wash');  
  } else {
  	$('.page-container').removeClass('wash');  
  }
  */
  
  $('.drawer-cover').toggle();    
  
  /*
  setTimeout(function() {
    if(($('.drawer').css('display') == 'none') && ($('#open_close').css('display') == 'none')) {
      $("#PageContainer").removeClass("wash");
    }
  },200);
  */
}

$('.drawer-cover').hover(function() {
  /*if($("#open_close").css('display') == 'none') {
    $('.page-container').removeClass('wash');  
  }*/
  
  // $('.drawer-cover').hide();
  // Fix slide error
  // $('.drawer').hide('slide', {direction: 'right'}, 400);
  hideCartDrawer()
  $('.cart-drawer__content').show();	
});

$('.drawer-cover').click(function() {
  // $('.page-container').removeClass('wash');  
  // $('.drawer-cover').hide();                                     
  hideCartDrawer(); // $('.drawer').hide('slide', {direction: 'right'}, 400);
  $('.cart-drawer__content').show();
});

function showacc() {
  hideCartDrawer();  // $('.drawer').hide('slide', {direction: 'right'}, 400);
  /*if($("#open_close").css('display') == 'block') {} else {
    $('.page-container').removeClass('wash');  
  }*/
  // $('.drawer-cover').hide();   
}

$(".user_icon").bind("mouseenter focusin", function(){
  $(this).find(".header_account").attr("aria-expanded", "true");
});

$(".user_icon").bind("mouseleave focusout", function(){
  $(this).find(".header_account").attr("aria-expanded", "false");
});

function my_menu(para) {
  $(".toplmenu1").toggle();
  $('.mobilemenu').slideToggle();
  $('.icon--nav-anim').toggleClass('open');  
  
  /*
  if(para==1) {
    $(".menu_div_two").hide();
    $(".toplmenu1").show();
    $('.mobilemenu').show();
  } else {
    $(".menu_div_two").show();
    $(".toplmenu1").hide();
    $('.mobilemenu').hide();   
  }
  */
}

function showd(element, para) {
  //$('.sndnn').hide();
  if($('.snd'+para).css('display') == 'none') {
    $('.snd'+para).show();
    $(element).children('.minus').show();
    $(element).children('.plus').hide();
  } else {
    $('.snd'+para).hide();
    $(element).children('.minus').hide();
    $(element).children('.plus').show();
  }
}

$(".refer_popup_sec1").click(function(){
  $("#open_close").slideToggle(500);
  $('#search').focus();
  $('.refer_popup_sec1').hide();
  // $("#PageContainer").toggleClass("wash");
  $(".search_icon").toggleClass("active");

  $('.cardrawr').remove($('.cardrawr div'));  
  $('.drawer').hide();
});

$("#users").mouseover(function(){$("#user_ac").show(2000);});

$("#users").mouseleave(function(){$("#user_ac").hide(2000);});

$(".slider").slick({
  infinite: true,
  dots: true,
  arrows: true,  
  autoplay: true,
  slidesToShow: 1,
  pauseOnHover:true,
  slidesToScroll: 1,
  responsive: [{
    breakpoint: 1024,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
    }
  }, {
    breakpoint: 768,
    settings: {
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1
    }
  },{
    breakpoint: 480,
    settings: {
      dots: true,
      arrows: false,   
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }]
});

$('.pause').on('click', function() {
  $('.slider').slick('slickPause');
  $('.pause').removeClass('active');
  $('.play').addClass('active');
});

$('.play').on('click', function() {
  $('.slider').slick('slickPlay');
  $('.pause').addClass('active');
  $('.play').removeClass('active');
});

$(".init-slider").slick({
  infinite: true,
  dots: false,
  arrows: true,               
  slidesToShow: 1,
  slidesToScroll: 1
});

$(".init-adaptive-slider").slick({
  infinite: true,
  dots: false,
  arrows: true,               
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: true
});

$(".init-dots-slider").slick({
  infinite: true,
  dots: true,
  arrows: true,               
  slidesToShow: 1,
  slidesToScroll: 1
});

$(".init-adaptive-dots-slider").slick({
  infinite: true,
  dots: true,
  arrows: true,               
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: true
});

$(".init-3d-slider").on('init', function(event, slick, direction){

}).on('swipe', function(event, slick, direction){
    
}).on('beforeChange', function(event, slick, currentSlide, nextSlide){

  $('.init-3d-slider-bar').slick('slickGoTo', nextSlide);

  var slider_bar_color;

  $(this).find('.slick-slide').each(function(){
      if ($(this).data('slick-index') == nextSlide){
        slider_bar_color = $(this).data('color');
      }
  });

  $('.doernbecher-banner-container').css('background', slider_bar_color);

}).slick({
  infinite: true,
  dots: false,
  arrows: false,               
  slidesToShow: 5,
  slidesToScroll: 1,
  adaptiveHeight: false,
  initialSlide: $(".init-3d-slider").data('slider-start'),
  draggable: false,
  focusOnSelect: true,
  swipe: false,
  swipeToSlide: false,
  centerMode: true
});

$('.init-3d-slider-bar').slick({
  infinite: true,
  dots: false,
  arrows: false,               
  slidesToShow: 5,
  slidesToScroll: 1,
  adaptiveHeight: false,
  initialSlide: $(".init-3d-slider").data('slider-start'),
  draggable: false,
  swipe: false,
  focusOnSelect: false,
  swipeToSlide: false,
  centerMode: true
});

$(".pro_groups").slick({
  infinite: true,
  dots: false,
  arrows: false,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [{
    breakpoint: 1024,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3
    }
  }, {
    breakpoint: 768,
    settings: {
      dots: false,
      slidesToShow: 2,
      slidesToScroll: 2
    }
  },{
    breakpoint: 480,
    settings: {
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }]
});

var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight){
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}

function popupFinder() {
    var t = $(this).data('popup-find');
    $('[data-popup="'+t+'"]').show();
}

// Removed price masking
/*
// remove after holiday - or modify and reuse
// @todo check if product has map price before overriding
const currentPromoItemTags = ['Black Friday', 'Cyber Monday', 'department_APPAREL', 'holiday_sale'];
const pricemodifier = 0.75;

function promoPriceChangerPDP() {
	// this will 'mask' the price on display to show a discount
	// that is actually automatically being applied in cart
	// @todo code around MAP rules
	// @todo code around whether discount is off original or current price
	const $pricediv = $('.product__price');
	let $meta = $pricediv.find('meta[data-current-price]');
	let currentprice = $meta.data('current-price');
	let originalprice = $meta.data('original-price');
	let promoprice = Math.round(currentprice*pricemodifier) / 100;
	const data = JSON.parse(document.getElementById('ProductJson-product-template').innerHTML);
	if( data.tags.includes(currentPromoItemTags[0]) || data.tags.includes(currentPromoItemTags[1]) ) {
		if(data.tags.includes(currentPromoItemTags[2])){
			$pricediv.find('.price__regular').html('<dd><s class="price-item price-item--regular" data-regular-price>$'+(Math.round(originalprice) / 100).toFixed(2)+'</s></dd>');
			$pricediv.find('.price__sale').remove();
			$pricediv.find('dl.price').removeAttr('data-price').addClass('price--on-sale').append('<div class="price__sale"><dd><span class="price-item price-item--sale">$'+(promoprice).toFixed(2)+'</span></dd></div>');
		}
	}
}
*/

const breakpoint = 760;

$(document).ready( function() {

	//body class for desktop
	if($(window).width() > breakpoint) {
		$('body').addClass('view--desktop');
	}

	$(window).scroll(function() {        
		if($(window).scrollTop() < 60) {
			$(".banner--clone").removeClass('banner--stick');
			$("body").removeClass('stickit');
		} else {             
			$(".banner--clone").addClass('banner--stick');
			$("body").addClass('stickit');
		}
	});

  	// popups
    $('[data-popup-find]').on('click', popupFinder);
    $('.popup').on('click', function(e) {
        if (e.target !== this) {return;}
        $(this).hide();
    });
    // universal popup hider for keypress
    $(document).keyup(function(e) {
    	if(e.key == "Escape") {
    		if($('.popup')[0]) {
        		$('.popup').hide();
    		}
    	}
    });

    $('.product-blog article').on('click', function() {
        $(this).toggleClass('open').find('.post').slideToggle();
    });

    // Removed price masking
    // if($('body').hasClass('template-product')) {promoPriceChangerPDP();}
});

/**
 * On: focus blur => Floating label
 * Based on http://jsfiddle.net/RyanWalters/z9ymd852/
*/
$('.input-box input, .input-box textarea , .input-box select , .control input').on('focus blur', function (e) {
  $(this).parents('.input-box , .control').toggleClass('in-use', (e.type === 'focus' || this.value.length > 0));

}).trigger('blur');

var yourNavigation = $(".form_search_result_me");
stickyDiv = "head_sticky_is-sticky";
yourHeader = $('.main_class').height();

$(window).scroll(function() {
  if( $(this).scrollTop() > yourHeader ) {
    yourNavigation.addClass(stickyDiv);
  } else {
    yourNavigation.removeClass(stickyDiv);
  }
});

var yourNavigations = $(".head_sticky");
stickyDivs = "head_sticky_is-sticky";
yourHeaders = $('.head_sticky').height();

$(window).scroll(function() {
  if( $(this).scrollTop() > yourHeaders ) {
    yourNavigations.addClass(stickyDivs);
    $('.header_account').addClass('header_account_active');
  } else {
    yourNavigations.removeClass(stickyDivs);
    $('.header_account').removeClass('header_account_active');
  }
});

$(".icon--circle").click(function(){
  if($(".asset-icons").hasClass('open')) {
    $(".asset-icons").removeClass('open').fadeIn(1000);
  } else {
    $(".asset-icons").addClass('open').fadeIn(1000);
  }

  if($(".icon-more").hasClass('open')) {
    $(".icon-more").removeClass('open')
  } else {
    $(".icon-more").addClass('open')
  }
});

$(".desktop-slider-champion").slick({
  infinite: true,
  dots: true,
  arrows: false,               
  slidesToShow: 1,
  slidesToScroll: 1
})

$(".nav--products-container").slick({
  infinite: true,
  dots: false,
  arrows: true, 
  centerMode: false,
  slidesToShow: 8,
  slidesToScroll: 1,
  responsive: [{
    breakpoint: 1024,
    settings: {
      slidesToShow: 6,
      slidesToScroll: 1,
    }
  }, {
    breakpoint: 768,
    settings: {
      dots: false,
      slidesToShow: 4,
      slidesToScroll: 1
    }
  },{
    breakpoint: 480,
    settings: {
      dots: false,
      slidesToShow: 3,
      slidesToScroll: 1
    }
  }]
});

function afterpay(para) {
  if(para==1) {
    $('.afterpay_main_popup').fadeIn(500);
  } else {
    $(".afterpay_main_popup").fadeOut(600);
  }
}

var yourNavigation_jordan = $(".jordan_sticky");
stickyDiv_jordan = "jordan_sticky_is_sticky";

yourHeader_jordan = $('.head_sticky ').height();

$(window).scroll(function() {
  if( $(this).scrollTop() > yourHeader_jordan ) {
    yourNavigation_jordan.addClass(stickyDiv_jordan);
  } else {
    yourNavigation_jordan.removeClass(stickyDiv_jordan);
  }
});

$(".head-slider").slick({
  infinite: true,
  dots: false,
  arrows: true,
  autoplay: true,
  slidesToShow: 1,
  pauseOnHover:true,
  slidesToScroll: 1
});
